export const apps = new Map([
  ['mg-mczx', {
    appId: 'dfaea59cabc3f6af16884dab3d57426e',
    schannel: '014X0JV',
    projectId: 'AI_HR_MCZX',
  }],
])
